import { Injectable } from '@angular/core';
import { CommonBackendResponse } from '../models/common-backend-response.model';

@Injectable({
  providedIn: 'root',
})
export class CommonBackendResponseHandlerService {
  constructor() {}

  getErrorMessageFromErrorCode(errorCode: string) {
    let errorMessage = '';
    if (!errorCode) {
      errorMessage = 'Some error occured, please try again.';
      return errorMessage;
    }
    errorCode = String(errorCode)?.replaceAll('-', '');
    switch (errorCode) {
      case '9500300':
        errorMessage =
          'We are not able to get your account details. Please contact operations team for support.';
        break;
      case '9500201':
        errorMessage =
          'We are not able to get your account details, as we are unable to connect to the database. Please contact operations team for support.';
        break;
      case '9500200':
        errorMessage = 'You are not authorized to use this application.';
        break;
      case '9800202':
        errorMessage = 'You are not authorized to use this application.';
        break;
      case '9800000':
        errorMessage =
          'You cannot use this application, as we are unable to connect to VA web service.  Please contact operations team for support.';
        break;
      case '9800300':
        errorMessage = 'You are not authorized to use this application.';
        break;
      case '9802600':
        errorMessage =
          'We are unable to validate address. Please contact operations team for support.';
        break;
      case '9803200':
        errorMessage =
          'We are unable to validate address. Please contact operations team for support.';
        break;
      case '9803401':
        errorMessage =
          'We are unable to validate SSN. Please contact operations team for support.';
        break;
      case '9803600':
        errorMessage =
          'We are unable to validate country. Please contact operations team for support.';
        break;
      case '9803700':
        errorMessage =
          'We are unable to some data. Please contact operations team for support.';
        break;
      case '9803903':
        errorMessage =
          'We are unable to get the data, as we are unable to connect to database. Please contact operations team for support.';
        break;
      case '9802300':
        errorMessage =
          'The driver license is already assigned to another person in Samba.';
        break;
      case '9800100':
        errorMessage = 'Samba was not able to validate data.';
        break;
      case '9800200':
        errorMessage = 'Unable to get user details from Samba.';
        break;
      case '9800400':
        errorMessage = 'Unable to get country details from Samba.';
        break;
      case '9800500':
        errorMessage = 'Unable to get state details from Samba.';
        break;
      case '9800600':
        errorMessage = 'Unable to get country and state details from Samba.';
        break;
      case '9800700':
        errorMessage = 'Unable to get relationship details from Samba.';
        break;
      case '9800800':
        errorMessage = 'Unable to authenticate in Samba.';
        break;
      case '9800900':
        errorMessage = 'Some internal error occured in Samba.';
        break;
      case '9801000':
        errorMessage =
          'The format of the request sent was not accepted by Samba.';
        break;
      case '9801100':
        errorMessage = 'The request is forbidden in Samba.';
        break;
      case '9801200':
        errorMessage = 'There are some resource conflicts in Samba.';
        break;
      case '9801300':
        errorMessage = 'Unable to get user details from Samba.';
        break;
      case '9801400':
        errorMessage = 'Unable to add user details in Samba.';
        break;
      case '9801500':
        errorMessage = 'Unable to update user details in Samba.';
        break;
      case '9801600':
        errorMessage = 'Unable to search user details in Samba.';
        break;
      case '9801700':
        errorMessage = 'Unable to add user license details in Samba.';
        break;
      case '9801800':
        errorMessage = 'Unable to update user license details in Samba.';
        break;
      case '9801900':
        errorMessage = 'Unable to search user license details in Samba.';
        break;
      case '9802000':
        errorMessage =
          'Unable to unenroll and enroll license details in Samba.';
        break;
      case '9802100':
        errorMessage = 'The user already exists in a group in Samba.';
        break;
      case '9802200':
        errorMessage = 'Unable to update user details in Samba.';
        break;

      case '9802400':
        errorMessage =
          'The driver license and state is already assigned to another person in Samba.';
        break;
      case '9802500':
        errorMessage =
          'Existing driver license number cannot be updated in Samba.';
        break;
      case '9802700':
        errorMessage = 'Unable to validate address.';
        break;
      case '9802900':
        errorMessage = 'Unable to validate user driver request.';
        break;
      case '9803000':
        errorMessage = 'Unable to get user driver license detail.';
        break;
      case '9803100':
        errorMessage = 'A duplicate driver license details was found.';
        break;
      case '9803300':
        errorMessage = 'Unable to get user addess data from database.';
        break;
      case '9803400':
        errorMessage = 'Unable to get SSN details.';
        break;
      case '9803500':
        errorMessage = 'A duplicate driver license details was found.';
        break;
      case '9804400':
        errorMessage = 'The zipcode was not validated by Samba.';
        break;
      case '9804500':
        errorMessage =
          'The driver license number format was not validated by Samba.';
        break;
      case '9805200':
        errorMessage = 'Data validation failed.';
        break;
      case '9805500':
        errorMessage = 'Something went wrong, please try again.';
        break;
      case '9805603':
        errorMessage = 'Unable to connect to database.';
        break;
      case '9805601':
        errorMessage = 'Unable to connect to database.';
        break;
      case '9500501':
        errorMessage = 'Vehicle history data not found.';
        break;
      case '9500400':
        errorMessage = 'No result found.';
        break;
      case '9806202':
        errorMessage = 'Blank token cannot be passed to VA web service.';
        break;
      case '9806100':
        errorMessage = 'No response from VA web service.';
        break;
      case '9806300':
        errorMessage = 'Unable to order MVR. Please rectify data.';
        break;
      case '9806400':
        errorMessage = 'MVR order not found.';
        break;
      case '9806500':
        errorMessage = 'Unable to order MVR. Please rectify data.';
        break;
      case '9806600':
        errorMessage = 'Unable to order MVR. Please rectify data.';
        break;
      case '9806700':
        errorMessage =
          'Unable to order MVR. Please reach out to vehicle administration.';
        break;
      case '9806800':
        errorMessage =
          'Unable to order MVR. Please reach out to vehicle administration.';
        break;
      case '9806900':
        errorMessage =
          'Unable to order MVR. Please reach out to vehicle administration.';
        break;
      case '9807000':
        errorMessage = 'MVR order status is pending.';
        break;
      case '9807600':
        errorMessage = 'Please provide a valid PDF consent document.';
        break;
      case '9807700':
        errorMessage = 'Unable to upload files, please try again later.';
        break;
      case '98011600':
        errorMessage =
          'This vehicle order is a invalid. Please try again later.';
        break;
      case '9806200':
        errorMessage =
          'Unable to place this vehicle order. Please try again later.';
        break;

      default:
        errorMessage = 'Some error occured, please try again.';
        break;
    }
    return errorMessage;
  }

  consolidateMessages(allMessages: string | string[], type: string) {
    try {
      if (!allMessages || !type) {
        throw new Error('Some error occured. Please try again.');
      }
      let consolidatedMessage = ``;
      if (type === 'success') {
        consolidatedMessage = `${allMessages?.length} data updated successfully.`;
      } else if (type === 'partialSuccess') {
        consolidatedMessage = `${allMessages?.length} data updated partially with some error.`;
      } else if (type === 'error') {
        consolidatedMessage = `Error updating ${allMessages?.length} data.`;
      } else if (type === 'failure') {
        consolidatedMessage = `Failed to update ${allMessages?.length} data.`;
      } else {
        throw new Error('Some error occured. Please try again.');
      }
      return consolidatedMessage;
    } catch {
      return 'Some error occured. Please try again.';
    }
  }

  generateErrorMessageForMaintenanceScreen(messageList: CommonBackendResponse) {
    let formattedMessages: string[] = [];

    if (Array.isArray(messageList)) {
      formattedMessages = messageList.map(
        (messageItem: CommonBackendResponse) => {
          let baseMessage = '';
          if (messageItem?.paramName) {
            baseMessage = `For parameter ${messageItem.paramName}`;
          } else if (messageItem?.modelCode) {
            baseMessage = `For model ${messageItem.modelCode}`;
          } else if (messageItem?.relationshipCode) {
            baseMessage = `For relationship ${messageItem.relationshipCode}`;
          }

          let messageDetails = 'an error occured';
          if (
            messageItem.errorMessages &&
            messageItem.errorMessages.length > 0
          ) {
            messageDetails = messageItem.errorMessages
              .map((messageValue: { messageText: string }) => {
                return `${messageValue.messageText.toLowerCase()}`;
              })
              .join(', ');
          }

          return `${baseMessage} ${messageDetails}.`;
        }
      );
    }

    return formattedMessages.join('\n');
  }

  generatePartialSuccessMessageForMaintenanceScreen(
    messageList: CommonBackendResponse
  ) {
    let formattedMessages: string[] = [];

    if (Array.isArray(messageList)) {
      formattedMessages = messageList.map(
        (messageItem: CommonBackendResponse) => {
          let baseMessage = '';
          if (messageItem?.paramName) {
            baseMessage = `For parameter ${messageItem.paramName}`;
          } else if (messageItem?.modelCode) {
            baseMessage = `For model ${messageItem.modelCode}`;
          } else if (messageItem?.relationshipCode) {
            baseMessage = `For relationship ${messageItem.relationshipCode}`;
          }

          let messageDetails = 'data is updated with some error';
          messageDetails = `${this.getErrorMessageFromErrorCode(
            messageItem?.errorcode || ''
          ).toLowerCase()}`;

          return `${baseMessage} ${messageDetails}.`;
        }
      );
    }

    return formattedMessages.join('\n');
  }

  generateSuccessMessageForMaintenanceScreen(
    messageList: CommonBackendResponse
  ) {
    let formattedMessages: string[] = [];
    if (Array.isArray(messageList)) {
      formattedMessages = messageList.map(
        (messageItem: CommonBackendResponse) => {
          let baseMessage = '';
          if (messageItem?.paramName) {
            baseMessage = `For parameter ${messageItem.paramName}`;
          } else if (messageItem?.modelCode) {
            baseMessage = `For model ${messageItem.modelCode}`;
          } else if (messageItem?.relationshipCode) {
            baseMessage = `For relationship ${messageItem.relationshipCode}`;
          }

          const messageDetails = 'data is updated';

          return `${baseMessage} ${messageDetails}.`;
        }
      );
    }
    return formattedMessages.join('\n');
  }

  generateErrorMessageForEmployeeAndAuthorizedDriverScreen(
    messageList: CommonBackendResponse
  ) {
    let formattedMessages: string[] = [];

    if (Array.isArray(messageList)) {
      formattedMessages = messageList.map(
        (messageItem: CommonBackendResponse) => {
          let baseMessage = '';
          baseMessage = `For ${messageItem?.firstName || ''} ${messageItem?.middleName || ''} ${messageItem?.lastName || ''}`;
          if (baseMessage.trim() === 'For') {
            baseMessage = `For user`;
          }
          let messageDetails = 'an error occured';
          if (
            messageItem.errorMessages &&
            messageItem.errorMessages.length > 0
          ) {
            messageDetails = `${this.getErrorMessageFromErrorCode(
              messageItem?.errorcode || ''
            ).toLowerCase()}`;
          }

          return `${baseMessage} ${messageDetails}`;
        }
      );
    }

    return formattedMessages.join('\n');
  }

  generatePartialSuccessMessageForEmployeeAndAuthorizedDriverScreen(
    messageList: CommonBackendResponse
  ) {
    let formattedMessages: string[] = [];

    if (Array.isArray(messageList)) {
      formattedMessages = messageList.map(
        (messageItem: CommonBackendResponse) => {
          let baseMessage = '';
          baseMessage = `For ${messageItem?.firstName || ''} ${messageItem?.middleName || ''} ${messageItem?.lastName || ''}`;
          if (baseMessage.trim() === 'For') {
            baseMessage = `For user`;
          }
          let messageDetails = 'data is updated with some error';
          messageDetails = `${this.getErrorMessageFromErrorCode(
            messageItem?.errorcode || ''
          ).toLowerCase()}`;

          return `${baseMessage} ${messageDetails}`;
        }
      );
    }

    return formattedMessages.join('\n');
  }

  generateSuccessMessageForEmployeeAndAuthorizedDriverScreen(
    messageList: CommonBackendResponse
  ) {
    let formattedMessages: string[] = [];
    if (Array.isArray(messageList)) {
      formattedMessages = messageList.map(
        (messageItem: CommonBackendResponse) => {
          let baseMessage = '';
          baseMessage = `For ${messageItem?.firstName || ''} ${messageItem?.middleName || ''} ${messageItem?.lastName || ''}`;
          if (baseMessage.trim() === 'For') {
            baseMessage = `For user`;
          }
          const messageDetails = 'data is updated';

          return `${baseMessage} ${messageDetails}.`;
        }
      );
    }
    return formattedMessages.join('\n');
  }
}
